import React, { useCallback, useEffect, useRef, useState } from "react";
import { IconButton, Box, Tooltip, Divider } from "@mui/material";
import { motion } from "framer-motion";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { applyAuthSession } from "../../redux/Apps/users/authSession";
import axios from "axios";
// import { FacebookRounded } from "@mui/icons-material";
import {
  backend_api,
  facebook_app_id,
  linkedIn_client_id,
} from "../../static/server";
import { useMsal } from "@azure/msal-react";

const SocialLinkBtn = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasRunRef = useRef(false);

  const [isLoading, setIsLoading] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const isLinkedInLogin = params.get("linked_in_login") === "true";

  useEffect(() => {
    if (hasRunRef.current) return;

    if (!isLinkedInLogin) return;

    const code = params.get("code");
    if (!code) {
      console.error("Invalid OAuth code");
      return;
    }

    hasRunRef.current = true;
    handleLinkedInCallback(code);
  }, [isLinkedInLogin]);

  const setupSession = useCallback(
    (responseData) => {
      if (!responseData) {
        toast.error("Invalid response data from server.");
        return null;
      }

      return applyAuthSession(dispatch, responseData, {
        clearPending: true,
      })?.tokenValue;
    },
    [dispatch],
  );

  const handleGoogleSuccess = async (credentialResponse) => {
    setIsLoading(true);

    try {
      if (credentialResponse?.credential) {
        const socialLinkPayload = {
          user_type: "lawyer",
          provider: "google",
          token: credentialResponse.credential,
        };

        const res = await axios.post(
          `${backend_api}user/social/login/`,
          socialLinkPayload,
        );

        if (res?.data?.data?.user) {
          setupSession(res.data.data.user);
          toast.success("Login successful!");
          navigate("/dashboard", { replace: true });
        } else {
          toast.error("Invalid response from server");
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    toast.error("Failed to login with Google");
  };

  const handleFaceBookLogin = () => {
    const redirectUri = encodeURIComponent(
      `${window.location.origin}/login/?facebook_in_login=true`,
    );
    const fbAuthUrl = `https://www.facebook.com/v19.0/dialog/oauth?client_id=${facebook_app_id}&redirect_uri=${redirectUri}&scope=email,public_profile`;

    window.location.href = fbAuthUrl;
  };

  const handleLinkedInLogin = () => {
    const redirectUri = encodeURIComponent(
      `${window.location.origin}/login/?linked_in_login=true`,
    );
    const scope = "openid profile email";
    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${linkedIn_client_id}&redirect_uri=${redirectUri}&scope=${encodeURIComponent(
      scope,
    )}`;

    window.location.href = authUrl;
  };

  const handleLinkedInCallback = async (code) => {
    try {
      const res = await axios.post(`${backend_api}user/social/login/`, {
        token: code,
        user_type: "lawyer",
        provider: "linkedin",
      });


      if (res?.data?.data?.user) {
        setupSession(res.data.data.user);
        toast.success("Login successful!");
        navigate("/dashboard", { replace: true });
      } else {
        toast.error("Invalid response from server");
      }
    } catch (err) {
      toast.error("Failed to login");
    }
  };

  // const handleMicrosoftLogin = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await instance.loginPopup({
  //       scopes: ["User.Read"],
  //     });

  //     const res = await axios.post(`${backend_api}user/social/login/`, {
  //       token: response.accessToken,
  //       user_type: "lawyer",
  //       provider: "microsoft",
  //     });

  //     if (res?.data?.data?.user) {
  //       setupSession(res.data.data.user);
  //       toast.success("Login successful!");
  //       navigate("/dashboard", { replace: true });
  //     } else {
  //       toast.error("Invalid response from server");
  //     }
  //   } catch (err) {
  //     console.error("Microsoft login error", err);
  //     toast.error("Microsoft login failed");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const iconButtonStyle = {
    width: 44,
    height: 44,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12)",
    transition: "all 0.2s ease",
    backgroundColor: "#fff",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  };

  const ColoredGoogleIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  );

  const MicrosoftIcon = () => (
    <svg width="20" height="20" viewBox="0 0 23 23">
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
      <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
    </svg>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        width: "100%",
      }}
    >
      <Divider sx={{ fontSize: "0.9rem", color: "text.secondary" }}>
        Or continue with
      </Divider>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 1.5,
        }}
      >
        <Tooltip title="Continue with Google" arrow>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Box sx={{ position: "relative", width: 44, height: 44 }}>
              {/* 1. Put GoogleLogin FIRST - let it render normally */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 10,
                  opacity: 0.01, // Almost invisible but still clickable
                }}
              >
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleGoogleError}
                  useOneTap={false}
                  type="icon"
                  size="large"
                  shape="circle"
                  theme="outline"
                  width="44"
                />
              </Box>

              {/* 2. Your custom icon ON TOP - same size */}
              <IconButton
                sx={{
                  width: 44,
                  height: 44,
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12)",
                  backgroundColor: "#fff",
                  position: "relative",
                  zIndex: 1, // Lower than Google button
                  pointerEvents: "none", // Let clicks pass through
                }}
              >
                <ColoredGoogleIcon />
              </IconButton>
            </Box>
          </motion.div>
        </Tooltip>

        {/* <Tooltip title="Continue with Microsoft" arrow>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <IconButton
              sx={{
                ...iconButtonStyle,
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                },
              }}
              onClick={handleMicrosoftLogin}
              disabled={isLoading}
            >
              <MicrosoftIcon />
            </IconButton>
          </motion.div>
        </Tooltip> */}

        {/* <Tooltip title="Continue with Facebook" arrow>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <IconButton
              sx={{
                ...iconButtonStyle,
                color: "#000000",
              }}
              onClick={handleFaceBookLogin}
              disabled={isLoading}
            >
              <FacebookRounded sx={{ fontSize: 20, color: "#3b5998" }} />
            </IconButton>
          </motion.div>
        </Tooltip> */}

        {/* <Tooltip title="Continue with LinkedIn" arrow>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <IconButton
              sx={{
                ...iconButtonStyle,
                color: "#0077B5",
                "&:hover": {
                  backgroundColor: "rgba(0, 119, 181, 0.08)",
                },
              }}
              onClick={handleLinkedInLogin}
              disabled={isLoading}
            >
              <LinkedInIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </motion.div>
        </Tooltip> */}
      </Box>
    </Box>
  );
};

export default React.memo(SocialLinkBtn);
